export default class OtherPossibleDeathReasons {
    constructor(suspectedCause, extraDetails, samplesForAnalysisRabies, rabiesLab) {
        this.suspectedCause = suspectedCause;
        this.extraDetails = extraDetails;
        this.samplesForAnalysisRabies = samplesForAnalysisRabies;
        this.rabiesLab = rabiesLab;
    }
}